import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PriceListEntry } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { PriceListEntryService } from '../../services/price-list-entry.service';

@Component({
  selector: 'app-price-list-entry-dropdown',
  templateUrl: './price-list-entry-dropdown.component.html',
  providers: [PriceListEntryService],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class PriceListEntryDropdownComponent extends GenericBaseModelDropDown<PriceListEntry> {

  constructor(private service: PriceListEntryService) {
    super(service, "PriceListEntry");
  }

}

